// extracted by mini-css-extract-plugin
export default {"delete":"similar-to-you--1J5mq"};